<div class="tc-backdrop" role="dialog" aria-modal="true" aria-labelledby="tc-title">
  <div class="tc-card">
    <header class="tc-head">
      <h1 id="tc-title" class="tc-title">Updated Terms &amp; Conditions</h1>
      <p class="tc-sub">
        Please review the new version ({{ gate().currentActive.version }}) before continuing. Effective
        {{ gate().currentActive.effectiveFrom | date: 'mediumDate' }}.
      </p>
    </header>

    <div #scroller class="tc-body" (scroll)="onScroll()" tabindex="0">
      <pre class="tc-body-text">{{ gate().currentActive.bodyMarkdown }}</pre>
    </div>

    @if (gate().graceEndsAt) {
      <div class="tc-notice" role="note">
        Re-acceptance is required by {{ gate().graceEndsAt | date: 'mediumDate' }} to avoid account suspension.
      </div>
    }

    <footer class="tc-footer">
      @if (!hasScrolledToEnd() && !submitting()) {
        <span class="tc-hint">Scroll to the bottom to accept.</span>
      }
      <button type="button" class="tc-button tc-button--ghost" (click)="cancel()" [disabled]="submitting()">
        Cancel &amp; sign out
      </button>
      <button type="button" class="tc-button" (click)="accept()" [disabled]="!hasScrolledToEnd() || submitting()">
        @if (submitting()) {
          <mat-spinner diameter="16" />
          Submitting…
        } @else {
          Accept &amp; continue
        }
      </button>
    </footer>
  </div>
</div>
